import { NgIf } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { DashboardOption } from 'src/app/models/dashboard-option';

declare function generateChart(elementId: string, data: any, type: string): any;

@Component({
  selector: 'app-line-chart',
  imports: [NgIf],
  templateUrl: './line-chart.component.html',
  styleUrl: './line-chart.component.css'
})
export class LineChartComponent {
  @Input() chartId!: string;
  @Input() icon!: string;
  @Input() title!: string;
  @Input() data!: DashboardOption[];
  @Input() series: string[] = [];

  @Input() isLoading: boolean = false;
  @Input() hasError: boolean = false;
  @Input() isNoData: boolean = false;

  @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;

  private chartInstance: any;

  // Define an array of colors.  Make sure you have enough colors!
  colors: string[] = [
    'rgba(54, 162, 235, 0.5)', // blue
    'rgba(255, 99, 132, 0.5)', // red
    'rgba(255, 206, 86, 0.5)', // yellow
    'rgba(75, 192, 192, 0.5)', // green
    'rgba(153, 102, 255, 0.5)', // purple
    'rgba(255, 159, 64, 0.5)', // orange
    // ... add more colors as needed
  ];

  borderColors: string[] = [
    'rgba(54, 162, 235, 1)', // blue
    'rgba(255, 99, 132, 1)', // red
    'rgba(255, 206, 86, 1)', // yellow
    'rgba(75, 192, 192, 1)', // green
    'rgba(153, 102, 255, 1)', // purple
    'rgba(255, 159, 64, 1)', // orange
    // ... add more colors as needed
  ];


  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue) {
      this.buildChart();
    }
  }

  private buildChart(): void {
    if (!this.data || this.data.length === 0) return;

    const labelsList = [...new Set(this.data.map(item => item.labelName))];

    if (this.series.length === 0) {
      this.series = [...new Set(this.data.map(item => item.serieName))];
    }

    const datasetList = this.series.map((serie, index) => {
      const backgroundColor = this.colors[index % this.colors.length]; // Cycle through colors
      const borderColor = this.borderColors[index % this.borderColors.length]; // Cycle through colors

      return {
        label: serie,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: 1,
        data: labelsList.map(label => {
          const item = this.data.find(d => d.labelName === label && d.serieName === serie);
          return item ? item.countValue : 0;
        })
      };
    });

    const lineBarChartData = {
      labels: labelsList,
      datasets: datasetList
    };

    const canvas = document.getElementById(this.chartId) as HTMLCanvasElement;
    if (canvas) {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }

      this.chartInstance = generateChart(this.chartId, lineBarChartData, 'line');
    }
  }
}